export default (axios, baseURL) => ({
  summary() {
    return axios.get(`${baseURL}/api/dashboard/summary`);
  },
});
